import Image from "next/image";
import RatingStar from "@/images/landing-redesign/hero/rating-star.svg";
import RatingStarEmpty from "@/images/landing-redesign/hero/rating-star-empty.svg";
import RatingArrow from "@/images/landing-redesign/hero/rating-arrow.svg";
import RatingImprovement from "@/images/landing-redesign/hero/rating-improvement.svg";

export function HeroRatingCard() {
  return (
    <div role="img" aria-label="Illustrative Trustpilot rating example" className="hero-rating-card w-full rounded-[15.793px] bg-white p-[13.161px] text-black/90 shadow-[0_15.793px_39.483px_-19.742px_rgba(16,40,44,.3)]">
      <div className="flex flex-col gap-[7.897px] rounded-[10.529px] bg-[#3c6e71]/[.08] p-[7.897px]">
        <div className="hero-rating-comparison relative flex items-end gap-[5.264px]">
          {[
            { value: "4.1", label: "Current", count: 4 },
            { value: "4.9", label: "Potential after removal", count: 5 },
          ].map(({ value, label, count }) => (
            <div
              key={label}
              className={`flex min-w-0 flex-col items-center gap-[3.29px] rounded-[7.897px] bg-white px-[15.793px] py-[5.264px] drop-shadow-[0_3.948px_5.264px_rgba(60,110,113,.09)] ${count === 4 ? "flex-1" : "w-[105.289px] shrink-0"}`}
            >
              <p
                className={`text-[18.426px] font-[590] leading-[17.109px] ${count === 5 ? "text-[#00ad5c]" : "text-black/90"}`}
              >
                {value}
              </p>
              <p
                className={`whitespace-nowrap font-jetbrains-mono text-[6.581px] font-semibold uppercase leading-[8.884px] tracking-[.1481px] ${count === 4 ? "text-[#8a8a98]" : "text-[#3c6e71]"}`}
              >
                {label}
              </p>
              <div className="flex gap-[1.316px]" aria-hidden="true">
                {Array.from({ length: 5 }, (_, index) => (
                  <Image
                    key={index}
                    src={index < count ? RatingStar : RatingStarEmpty}
                    alt=""
                    className="size-[10.529px]"
                  />
                ))}
              </div>
            </div>
          ))}
          <div className="hero-rating-improvement absolute left-1/2 top-[calc(50%-12.1px)] flex -translate-x-1/2 -translate-y-1/2 items-center gap-[1.974px] rounded-full bg-[#00ad5c] py-[1.974px] pl-[5.264px] pr-[1.974px] drop-shadow-[0_2.632px_4.08px_rgba(0,173,92,.39)]">
            <span className="whitespace-nowrap font-jetbrains-mono text-[9.213px] font-bold leading-[9.871px] text-white">
              +0.8★
            </span>
            <span className="relative size-[10.529px] overflow-hidden rounded-full bg-white">
              <Image
                src={RatingArrow}
                alt=""
                className="absolute left-[.23px] top-[-.33px] size-[10.529px]"
              />
            </span>
          </div>
        </div>
        <div className="hero-rating-explanation flex items-center gap-[7.897px] rounded-[7.897px] border-[.658px] border-[#3c6e71]/10 bg-[#f5fcfc] p-[5.264px] drop-shadow-[0_3.948px_5.264px_rgba(60,110,113,.11)]">
          <span className="grid size-[21.058px] shrink-0 place-items-center rounded-[5.264px] bg-[#00ad5c]/10">
            <Image src={RatingImprovement} alt="" className="size-[15.793px]" />
          </span>
          <p className="min-w-0 flex-1 text-[7.897px] leading-[1.46]">
            Example: removing{" "}
            <strong className="font-bold text-[#00ad5c]">65 reviews</strong>{" "}
            could change the rating by{" "}
            <strong className="font-bold text-[#00ad5c]">+0.8★.</strong>
          </p>
        </div>
      </div>
    </div>
  );
}
